import React from 'react';
import { STD_TEMPLATE } from '../../utils/constants';

function ResponseCapture({ feasibility, cro, onUpdate, readOnly = false }) {
  const responses = feasibility.responses?.[cro] || {};

  const setResponse = (qId, val) => {
    if (readOnly) {
      return;
    }

    const next = {
      ...feasibility,
      responses: {
        ...feasibility.responses || {},
        [cro]: { ...feasibility.responses?.[cro] || {}, [qId]: val }
      }
    };
    onUpdate(next);
  };

  return (
    <div>
      {STD_TEMPLATE.sections.map((section) => {
        const sectionScores = section.questions.map((q) => {
          const r = responses[q.id];
          if (r == null || r === '') return null;
          if (q.type === 'yesno') return r === 'yes' ? 10 : r === 'partial' ? 5 : 0;
          if (q.type === 'scale') return Number(r) || 0;
          return 0;
        });
        const answered = sectionScores.filter((s) => s !== null).length;

        return (
          <div key={section.id} className="mb-4">
            <div className="flex between center mb-2">
              <div className="bold sm">{section.name}</div>
              <div className="xs muted">Weight {section.weight} · {answered}/{section.questions.length} answered</div>
            </div>

            {section.questions.map((q) => (
              <div key={q.id} className="card-pad" style={{ background: 'var(--surface-2)', borderRadius: 2, marginBottom: 8, border: '1px solid var(--line)' }}>
                <div className="sm mb-2">
                  <span className="mono xs muted" style={{ marginRight: 6 }}>{q.id.toUpperCase()}</span>
                  {q.text}
                </div>

                {q.type === 'yesno' ? (
                  <div className="flex gap-2">
                    {['yes', 'partial', 'no'].map((opt) => (
                      <button
                        key={opt}
                        className={`btn btn-sm ${responses[q.id] === opt ? 'btn-primary' : ''}`}
                        disabled={readOnly}
                        onClick={() => setResponse(q.id, opt)}
                      >
                        {opt === 'yes' ? '✓ Yes' : opt === 'partial' ? '◐ Partial' : '✗ No'}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="flex gap-2 center">
                    {[1, 3, 5, 7, 9, 10].map((v) => (
                      <button
                        key={v}
                        className={`btn btn-sm ${responses[q.id] == v ? 'btn-primary' : ''}`}
                        style={{ minWidth: 36, justifyContent: 'center' }}
                        disabled={readOnly}
                        onClick={() => setResponse(q.id, v)}
                      >
                        {v}
                      </button>
                    ))}
                    <span className="xs muted" style={{ marginLeft: 8 }}>1 = poor, 10 = excellent</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

export default ResponseCapture;